import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTabsModule } from '@angular/material/tabs';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatStepperModule } from '@angular/material/stepper';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatListModule } from '@angular/material/list';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTreeModule } from '@angular/material/tree';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { PopupDialogComponent } from './popup-dialog/popup-dialog.component';
import { LoadingModule } from '../loading/loading.module';
import { GoogleMapLoaderService } from '../handler/google-map-loader';
import { MobileDialogComponent } from './mobile-dialog/mobile-dialog.component';
import { LocationSetDialogComponent } from './location-set-dialog/location-set-dialog.component';
import { VariantSelectionDialogComponent } from './variant-selection-dialog/variant-selection-dialog.component';
import { BottomSheetDialogComponent } from './bottom-sheet-dialog/bottom-sheet-dialog.component';
import { SpinWheelDialogComponent } from './spin-wheel-dialog/spin-wheel-dialog.component';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
@NgModule({
  declarations: [
    PopupDialogComponent,
    MobileDialogComponent,
    LocationSetDialogComponent,
    VariantSelectionDialogComponent,
    BottomSheetDialogComponent,
    SpinWheelDialogComponent
  ],
  exports: [
    PopupDialogComponent,
    MobileDialogComponent,
    LocationSetDialogComponent,
    VariantSelectionDialogComponent,
    BottomSheetDialogComponent,
    SpinWheelDialogComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatSidenavModule,
    MatTabsModule,
    MatCardModule,
    MatDividerModule,
    MatPaginatorModule,
    MatTableModule,
    MatChipsModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    MatRadioModule,
    MatSlideToggleModule,
    FormsModule,
    MatAutocompleteModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    FlexLayoutModule,
    MatDatepickerModule,
    MatListModule,
    MatTabsModule,
    MatSnackBarModule,
    MatSelectModule,
    MatDialogModule,
    MatSidenavModule,
    MatToolbarModule,
    MatButtonToggleModule,
    MatTreeModule,
    MatProgressBarModule,
    MatStepperModule,
    MatTooltipModule,
    MatBottomSheetModule,
    LoadingModule
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())]
})
export class ElementWidgetsModule {
  constructor() {
    GoogleMapLoaderService.load().then(() => {});
  }
}
